/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The ReplaceSensorRequest model module.
* @module model/ReplaceSensorRequest
* @version 2020-12-7
*/
export default class ReplaceSensorRequest {
    /**
    * Constructs a new <code>ReplaceSensorRequest</code>.
    * センサー交換リクエスト
    * @alias module:model/ReplaceSensorRequest
    * @class
    * @param timestamp {Number} 交換が行われた時刻
    */

    constructor(timestamp) {
        
        
        this['timestamp'] = timestamp;
        
    }

    /**
    * Constructs a <code>ReplaceSensorRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/ReplaceSensorRequest} obj Optional instance to populate.
    * @return {module:model/ReplaceSensorRequest} The populated <code>ReplaceSensorRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ReplaceSensorRequest();
                        
            
            if (data.hasOwnProperty('replaceFrom')) {
                obj['replaceFrom'] = ApiClient.convertToType(data['replaceFrom'], 'Number');
            }
            if (data.hasOwnProperty('replaceTo')) {
                obj['replaceTo'] = ApiClient.convertToType(data['replaceTo'], 'Number');
            }
            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'Number');
            }
        }
        return obj;
    }

    /**
    * 取り外されたセンサーのID. 設定されていなければ未設置
    * @member {Number} replaceFrom
    */
    'replaceFrom' = undefined;
    /**
    * 取り付けられたセンサーのID. 設定されていなければ未設置
    * @member {Number} replaceTo
    */
    'replaceTo' = undefined;
    /**
    * 交換が行われた時刻
    * @member {Number} timestamp
    */
    'timestamp' = undefined;




}
